module.exports = __webpack_public_path__ + "img/clock.d0ecc2c4.svg";